import React from 'react';
import LabeledAppraisalAssignedCount from './LabeledAppraisalAssignedCount';

/**
 * @typedef {object} LabeledEventAssignmentCountProps
 * @property {string} [label]
 * @property {Object} [data]
 * @property {boolean} [loading]
 */

/**
 * @param {LabeledEventAssignmentCountProps} props
 */
const LabeledEventAssignmentCount = props => {
  const { label, data, loading } = props;
  const displayText = `${data?.CurrentAmount}/${data?.AmountLimit}`;

  return <LabeledAppraisalAssignedCount label={label} loading={loading} text={displayText} />;
};

export default LabeledEventAssignmentCount;
